import type { PromptListStatus, PromptListTopBrand } from '../types';
import { resolveAiMentions } from './visibility-metrics';

export function isPromptExecutedForBrands(
  status: PromptListStatus,
  runs: number,
): boolean {
  if (runs > 0) return true;
  return status === 'executed' || status === 'partial' || status === 'failed';
}

export type PromptTopBrandsDisplay =
  | { kind: 'not-run' }
  | { kind: 'no-brands' }
  | { kind: 'brands'; brands: PromptListTopBrand[] };

export function resolvePromptTopBrandsDisplay(
  status: PromptListStatus,
  runs: number,
  brands: PromptListTopBrand[],
): PromptTopBrandsDisplay {
  if (!isPromptExecutedForBrands(status, runs)) {
    return { kind: 'not-run' };
  }
  if (!brands.length) {
    return { kind: 'no-brands' };
  }
  return { kind: 'brands', brands };
}

export function sortPromptListBrands(brands: PromptListTopBrand[]): PromptListTopBrand[] {
  return [...brands].sort((a, b) => {
    if (b.visibilityScore !== a.visibilityScore) {
      return b.visibilityScore - a.visibilityScore;
    }
    const aPos = a.avgPosition ?? Number.MAX_SAFE_INTEGER;
    const bPos = b.avgPosition ?? Number.MAX_SAFE_INTEGER;
    if (aPos !== bPos) return aPos - bPos;
    return resolveAiMentions(b) - resolveAiMentions(a);
  });
}
